(function () {
  function init(root) {
    const pins = root.querySelectorAll('.stl-pin');
    const popups = root.querySelectorAll('.stl-popup');

    function closeAll() {
      popups.forEach((p) => { p.hidden = true; });
    }

    pins.forEach((pin) => {
      pin.addEventListener('click', (e) => {
        e.stopPropagation();
        const targetId = pin.getAttribute('data-pin-target');
        const target = root.querySelector('#' + targetId);
        if (!target) return;
        const wasOpen = !target.hidden;
        closeAll();
        target.hidden = wasOpen;
      });
    });

    popups.forEach((popup) => {
      const close = popup.querySelector('.stl-popup__close');
      if (close) {
        close.addEventListener('click', () => { popup.hidden = true; });
      }
      popup.addEventListener('click', (e) => e.stopPropagation());
    });

    root.addEventListener('click', closeAll);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeAll();
    });
  }

  function boot() {
    document.querySelectorAll('.stl-section').forEach((el) => {
      if (el.__stlReady) return;
      el.__stlReady = true;
      init(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
